import { Injectable, inject } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

const anyWindow = <any>window;
@Injectable({
  providedIn: 'root'
})
export class RouterService {
  private router = inject(Router);
  private location = inject(Location);

  getActivatedRouteSnapshot() {

    let route = this.router.routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
    }

    return route.snapshot;
  }

  navigate(params) {
    this.rewriteUrl(params.join('/'));
    this.router.navigate(params);
  }

  navigateByUrl(url, target) {
    if (!target && url && (url.startsWith('/form') || url.startsWith('form/'))) {
      this.rewriteUrl(url);
      this.router.navigate([url]);
    } else {
      anyWindow.open(url, target || '_self');
    }
  }

  getCurrentUrl() {
    return this.router.url;
  }

  /**
   * Writes the target address into the address bar ahead of the router navigation, so
   * components that read `window.location` see the new address straight away (16501).
   *
   * A history entry is only pushed when the target address differs from the one the browser
   * is already showing. Saving a document routes to the document that is already open, and
   * pushing an entry for that identical address left the browser Back button returning to
   * the same document - once per save performed.
   *
   * @param url - the target address, with or without a leading slash, e.g. `form/<documentId>`
   * @param title - optional title passed through to `history.pushState`
   */
  rewriteUrl(url: string, title?: string) {
    const targetUrl = url.startsWith('/') ? url : `/${url}`;

    if (this.location.isCurrentPathEqualTo(targetUrl)) {
      return;
    }

    anyWindow.history.pushState({}, title, this.location.prepareExternalUrl(targetUrl));
  }

}
